module.exports = __webpack_public_path__ + "static/collectorcans-kait-artwork-b39f3efc1904253b48c5984cbef6e704.png";